
export class RevamppDataAsset {
    Name: string = "";
    Type: string = "";
    NdeId: string = "";
    NdeLink: string = "";
    Source: DataAssetSource[] = [];
    Description: string = "";
    CenterList: string[] = [];
    LastModified: Date = new Date(1, 1, 1);
    AuthorList: string[] = [];
    PublicationIdList: string[] = [];
    Url: string = "";
    SearchTerms: string[];
    HealthConditionList: string[];
    MeasurementTechniqueList: string[];
    SpeciesList: string[];
    TopicCategoryList: string[];
    InfectiousAgentList: string[];
    VariablesMeasuredList: string[];

    constructor() { }
}

export class DataAssetSource {
    Name: string = "";
    Url: string = "";

    constructor() { }
}